<template>
	<div v-if="values">
		<multiselect v-model="selectedValue" 
			:options="values" 
			:placeholder="placeholder" 
			label="text" track-by="value"
			:allow-empty="allowEmpty"
			:multiple="multiple" :taggable="taggable"
			:disabled="readOnly"
			@tag="onAddTag"
			:showNoOptions="true"
			tagPlaceholder="Premere invio per creare"
			selectLabel="Premere invio per selezionare"
			deselectLabel="Premere invio per rimuovere"
			selectedLabel="Selezionato"
			>
			<template #noOptions>
				{{noOptions}}
			</template>
		</multiselect>
		<input :id="inputName" :name="inputName" v-model="outValue" type="hidden" />
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { setTimeout } from 'timers';
import DataUtils from '../../../utils/DataUtils';

export default {
	components: {
		Multiselect
	},
	props: {
		inputName: {
			type: String
		},
		value: {
			type: [String, Number, Object, Array]
		},
		values:{
		},
		allowEmpty: {
			type: Boolean,
			default: true
		},
		multiple: {
			type: Boolean,
			default: false
		},
		taggable: {
			type: Boolean,
			default: false
		},
		readOnly:{
			type: Boolean,
			default: false
		},
		canAddValues: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: "Selezionare un valore"
		},
		noOptions: {
			type: String,
			default: "Nessun valore presente"
		}
	},
	data() {
		return {
			test: "a",
			selectedValue: [],
			outValue: null
		};
	},
	computed: {
	},
	watch:{
		value(newValue){
			this.selectedValue = newValue
		},
		selectedValue(newValue){
			this.outValue = DataUtils.encodeData(newValue);

			if (newValue){
				this.$emit('input', newValue);
			} else {
				this.$emit('input', null);
			}
		},
		outValue(){
			setTimeout(() => {
				this.emitChange();
			}, 10);
		},
	},
	mounted(){
		window.$(function() {
			var preventFormSubmit = false;
			window.$('.multiselect__input').focusout(function(){
				setTimeout(() => {
					preventFormSubmit = false;
				}, 100);
			});
            window.$(window).keydown(function(event){
                if(event.keyCode == 13) {
                    if (event.target.className == 'multiselect__input'){
                        preventFormSubmit = true;
                    } else {
                        preventFormSubmit = false;
                    }
                }
            });

            window.$('form').on('submit', function(event){
                if (preventFormSubmit){
                    event.preventDefault();
                    return false;
                }
            });
		});
	},
	methods:{
		onAddTag(newTag){
			if (!this.canAddValues){
				return
			}

			const tag = {
				text: newTag,
				value: "new-tag " + Math.floor((Math.random() * 10000000))
			}
			this.values.push(tag)
			if(this.multiple){
				this.selectedValue.push(tag)
			} else {
				this.selectedValue = tag
			}
		},
		emitChange(){
			let el = document.getElementById(this.inputName);
			if (el == null){
				return;
			}

			if ("createEvent" in document) {
				var evt = document.createEvent("HTMLEvents");
				evt.initEvent("change", false, true);
				el.dispatchEvent(evt);
			} else {
				el.fireEvent("onchange");
			}
		}
	}
};
</script>